import {io, Socket} from 'socket.io-client';
import {getFreshAccessToken, websocketPath} from "../api";

class SocketService {
    private socket: Socket | null = null;
    private static instance: SocketService;

/*    private constructor() {
    }*/

    public static getInstance(): SocketService {
        if (!SocketService.instance) {
            SocketService.instance = new SocketService();
        }
        return SocketService.instance;
    }

    public connect(url: string = websocketPath): Socket {
        if (!this.socket) {
            this.socket = io(url, {
                // Токен берётся заново при каждой попытке подключения,
                // а не один раз при создании сокета. Истекает — сначала общее
                // обновление, как у HTTP-запросов (S4.3, api/index.ts).
                auth: (cb) => {
                    void getFreshAccessToken().then((token) => cb({token}));
                },
                transports: ['websocket', 'polling'],
                reconnection: true,
                reconnectionDelay: 1000,
                reconnectionDelayMax: 10000,
                randomizationFactor: 0.5,
                // Бесконечные попытки — пусть socket.io сам разруливает backoff
                reconnectionAttempts: Infinity,
                timeout: 20000,
            });

            this.socket.on('connect_error', (error) => {
                // warn, а не error: при каждом обрыве сети попытки переподключения не должны краснить консоль (S4.3).
                console.warn('🔴 WebSocket connection error:', error.message);
            });

            // Страховка: если socket.io всё же сдался — поднимаем вручную
            this.socket.io.on('reconnect_failed', () => {
                console.warn('⚠️ Reconnect failed, retrying manually in 5s...');
                setTimeout(() => this.socket?.connect(), 5000);
            });
        }

        return this.socket;
    }

    public reconnectWithNewToken(): void {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
        this.connect();
    }

    public getSocket(): Socket | null {
        return this.socket;
    }

    public disconnect(): void {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }
}

export default SocketService.getInstance();
